import cn from 'classnames';
import Image from 'next/image';

const Card = ({ className, img, overtitle, title, body, children }) => (
  <div className={cn('overflow-hidden flex flex-col h-full bg-neutral-800', className)}>
    <div style={{ height: img.height ?? 160 }} className="relative overflow-hidden">
      <Image
        src={img.src}
        alt={img.alt}
        layout="fill"
        objectFit="cover"
        quality={100}
        loading="eager"
      />
    </div>
    <div className="flex-1 p-6">
      {overtitle && <p className={overtitle.className}>{overtitle.text}</p>}
      <p className="text-lg text-white">{title}</p>
      {body}
    </div>
    {children}
  </div>
);

Card.defaultProps = {
  className: '',
  img: {
    src: '/static/global/scale.png',
    alt: 'scale',
    height: 160
  },
  overtitle: undefined,
  title: '',
  body: undefined,
  children: undefined
};

export default Card;
